import { INIT, INIT_SUCCESS, INIT_FAILED } from './constants';

export interface InitAction {
  type: typeof INIT;
}

export interface InitSuccessAction {
  type: typeof INIT_SUCCESS;
}

export interface InitFailedAction {
  type: typeof INIT_FAILED;
  error: any;
}

export const initAction = (): InitAction => ({
  type: INIT,
});

export const initSuccessAction = (): InitSuccessAction => ({
  type: INIT_SUCCESS,
});

export const initFailedAction = (error: Error | string): InitFailedAction => ({
  type: INIT_FAILED,
  error,
});
